import { initializeApp } from "firebase/app";
import {
  createUserWithEmailAndPassword,
  getAuth,
  onAuthStateChanged,
  signInWithEmailAndPassword,
  signOut,
  setPersistence,
  browserSessionPersistence,
} from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

// Set up Firebase
const firebaseConfig = {
 apiKey: "AIzaSyDfbx0A0xalduY5KgMcbrSqU_dJaY7UMKk",
  authDomain: "enzocoin-3b126.firebaseapp.com",
  projectId: "enzocoin-3b126",
  storageBucket: "enzocoin-3b126.appspot.com",
  messagingSenderId: "321485431639",
  appId: "1:321485431639:web:2fdec8f4a1c1c630619412"
};

const app = initializeApp(firebaseConfig);

const auth = getAuth();
const db = getFirestore(app);

const storage = getStorage(app);

// Listen only for logged in state

export {
  app,
  auth,
  db,
  storage,
  onAuthStateChanged,
  signOut,
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
  browserSessionPersistence,
  setPersistence,
};
